// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <p>
//           main query page
//         </p>
//       </header>
//     </div>
//   );
// }


import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import EntryPage from "./pages/EntryPage";
import TutorialPage from "./pages/TutorialPage";
import FilterPage from "./pages/FilterPage";
import TablePage from "./pages/TablePage";
import StudyPage from "./components/studypage/StudyPage";
import TimelineTool from "./components/timeline/TimelineTool";
// import AssayPage from "./components/assaypage/AssayPage";
// import QueryNavbar from './components/main/Navbar.js';
// import Footer from './components/main/Footer.js';

import './App.css';
import './components/main/MainComponents.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import $ from 'jquery'; 



function App() {

  $('.nav-item:first a:first').addClass('active');

  return (  
    
    <div>

      {/* <QueryNavbar /> */}

      <Router>
        <Routes>
          {/* <Route path="/query/entry" element={<EntryPage />} /> */}
          {/* <Route path="/query/tutorial" element={<TutorialPage />} /> */}
          <Route path="/query/filters" element={<FilterPage />} />
          <Route path="/query/results" element={<TablePage />} />
          <Route path="/query/study/:id" element={<StudyPage />} />
          {/* <Route path="query/assay/:id_assay_group/:id_study_id" element={<AssayPage />} /> */}
          <Route path="/query/timeline_tool" element={<TimelineTool/>} />
        </Routes>
      </Router>

      {/* <Footer /> */}

    </div>
         
      
  );
}

export default App;


